"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/Compose/useToSearch.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _contact = require('shared/enum/contact');
var _createNew = require('shared/hooks/createNew');
var _useSearchQuery = require('shared/hooks/useSearchQuery');
var _inviteContact = require('shared/services/inviteContact');
var _newChatFlow = require('shared/services/createNew/newChatFlow');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _InviteContactModal = require('web/screens/InviteContactModal'); var _InviteContactModal2 = _interopRequireDefault(_InviteContactModal);




























// The results fill New chat's list, so more than a popover's handful.
const SEARCH_LIMIT = 20

// Looks like someone is typing a phone number: digits and phone punctuation.
const PHONE_LIKE = /^[\d\s()+.-]+$/
const digitCount = (q) => q.replace(/\D/g, '').length

 const searchOptionId = (index) => `new-chat-opt-${index}`; exports.searchOptionId = searchOptionId

/* What's typed in To and what it finds: the directory search grouped into
 * Coworkers and teams, Patients and Outside collaborators; the highlighted
 * result (arrow keys, Enter picks); Escape clears the text first; Backspace
 * (or Delete) on an empty To selects the last chip, then removes it, as in
 * WhatsApp; and the
 * invite dialog for a new patient or coworker, filled in from the text. New
 * chat shows the results in place of its list. */
 const useToSearch = ({
  orgKey,
  patientOrgKey,
  canAddPatients,
  canAddStaff,
  selectedEntitiesList,
  excludedEntitiesMap,
  inputRef,
  onSelectEntity,
  onInvitedEntity,
  onRemoveEntity,
}) => {
  const onLookup = _react.useCallback.call(void 0, 
    (Query, Limit) => _actions2.default.directoryLookup({
      Query,
      Limit,
      ...(canAddPatients && orgKey ? { PatientOrgKey: orgKey } : {}),
    }),
    [canAddPatients, orgKey],
  )
  const {
    searchQuery,
    setSearchQuery,
    clearSearchQuery,
    searchContactType,
    isLoadingResults,
    internalEntitiesList,
    externalEntitiesList,
    patientEntitiesList,
  } = _createNew.useSearch.call(void 0, {
    orgKeyContext: orgKey,
    listLimit: SEARCH_LIMIT,
    canAddUsers: canAddStaff,
    canAddTeams: canAddStaff,
    canAddPatients,
    excludedEntitiesMap,
    onLookup,
  })
  // The chip Backspace or a click picked out; typing, leaving To or a change
  // of people lets it go.
  const [selectedChip, setSelectedChip] = _react.useState(null)
  _react.useEffect.call(void 0, () => setSelectedChip(null), [selectedEntitiesList])
  const selectChip = _react.useCallback.call(void 0, (key) => {
    setSelectedChip(current => (current === key ? null : key))
    _optionalChain([inputRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()])
  }, [inputRef])
  const deselectChip = _react.useCallback.call(void 0, () => setSelectedChip(null), [])
  const setQuery = _react.useCallback.call(void 0, (q) => {
    setSelectedChip(null)
    setSearchQuery(q)
  }, [setSearchQuery])
  const clearQuery = _react.useCallback.call(void 0, () => clearSearchQuery(), [clearSearchQuery])

  const [active, setActive] = _react.useState.call(void 0, 0)
  const [inviteRelType, setInviteRelType] = _react.useState(null)
  const [inviteQuery, setInviteQuery] = _react.useState.call(void 0, '')
  const trimmed = _useSearchQuery.sanitizeSearchQuery.call(void 0, searchQuery).trim()

  const isPhoneLike = !!trimmed && PHONE_LIKE.test(trimmed) && digitCount(trimmed) >= 3
  const isCompletePhone = searchContactType === _contact.CONTACT_TYPES.PHONE
  const phoneError = isPhoneLike && !isCompletePhone && digitCount(trimmed) >= 7
    ? `${trimmed} isn't a complete phone number. US numbers have 10 digits; numbers outside the US and Canada aren't supported.`
    : null

  const groups = _react.useMemo.call(void 0, () => {
    if (!trimmed) return []
    const toOptions = (list) => list.map(entity => ({ id: entity.entityKey, entity }))
    return [
      { label: 'Coworkers and teams', options: toOptions(internalEntitiesList) },
      { label: 'Patients', options: toOptions(canAddPatients ? patientEntitiesList : []) },
      { label: 'Outside collaborators', options: toOptions(externalEntitiesList) },
    ].filter(group => group.options.length)
  }, [trimmed, canAddPatients, patientEntitiesList, internalEntitiesList, externalEntitiesList])

  const options = _react.useMemo.call(void 0, () => groups.flatMap(group => group.options), [groups])
  _react.useEffect.call(void 0, () => setActive(0), [trimmed, options.length])

  const pick = _react.useCallback.call(void 0, (option) => {
    if (!option) return
    onSelectEntity(option.entity)
    clearQuery()
    _optionalChain([inputRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
  }, [onSelectEntity, clearQuery, inputRef])
  // Add a patient / coworker / external collaborator: the invite dialog,
  // filled in from what's typed.
  const openInvite = _react.useCallback.call(void 0, (relType) => {
    setInviteQuery(trimmed)
    setInviteRelType(relType)
  }, [trimmed])

  // An Escape that clears the typed text stops there: a dialog around To
  // (New chat) closes on Escape's keyup.
  const hasClearedOnEscapeRef = _react.useRef.call(void 0, false)
  const onKeyUp = _react.useCallback.call(void 0, (e) => {
    if (e.key !== 'Escape' || !hasClearedOnEscapeRef.current) return
    hasClearedOnEscapeRef.current = false
    e.stopPropagation()
  }, [])
  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key === 'Escape') hasClearedOnEscapeRef.current = !!searchQuery
    if (e.key === 'ArrowDown' && options.length) setActive(i => (i + 1) % options.length)
    else if (e.key === 'ArrowUp' && options.length) setActive(i => (i - 1 + options.length) % options.length)
    // To is one line of text, however it wraps: Enter never adds a line.
    else if (e.key === 'Enter') { if (options.length) pick(options[active]) }
    else if (e.key === 'Escape' && searchQuery) clearQuery()
    else if ((e.key === 'Backspace' || e.key === 'Delete') && !searchQuery && selectedEntitiesList.length) {
      const { selected, remove } = _newChatFlow.chipBackspace.call(void 0, selectedEntitiesList.map(entity => entity.entityKey), selectedChip)
      if (remove) onRemoveEntity(remove)
      setSelectedChip(selected)
    } else return
    e.preventDefault()
  }, [searchQuery, options, active, pick, clearQuery, selectedEntitiesList, selectedChip, onRemoveEntity])

  const onCloseInvite = _react.useCallback.call(void 0, () => setInviteRelType(null), [])
  // The new contact comes back as a chip.
  const onEntityInvited = _react.useCallback.call(void 0, (entity) => {
    onInvitedEntity(entity)
    clearQuery()
    _optionalChain([inputRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
  }, [onInvitedEntity, clearQuery, inputRef])
  const inviteCredentials = _react.useMemo.call(void 0, () => {
    const isPhone = PHONE_LIKE.test(inviteQuery) && digitCount(inviteQuery) >= 7
    const isEmail = inviteQuery.includes('@')
    return _inviteContact.parseSearchQuery.call(void 0, inviteQuery, isPhone ? _contact.CONTACT_TYPES.PHONE : isEmail ? _contact.CONTACT_TYPES.EMAIL : null)
  }, [inviteQuery])

  const inviteModal = (
    _react2.default.createElement(_InviteContactModal2.default, {
      isOpen: !!inviteRelType,
      onClose: onCloseInvite,
      contactRelType: inviteRelType,
      defaultPhone: inviteCredentials.phone,
      defaultEmail: inviteCredentials.email,
      defaultFirstName: inviteCredentials.firstName,
      defaultLastName: inviteCredentials.lastName,
      // SAFETY: New chat always has an org to search; the dialog only opens
      // from a typed row, which needs one.
      orgKeyContext: orgKey ,
      // The current org is From's: with a texting team there it's filled
      // in, otherwise the dialog asks for the patient's org.
      pinnedOrgKey: inviteRelType === _contact.CONTACT_REL_TYPES.PATIENT ? patientOrgKey || orgKey : null,
      patientPinnedOrgKey: patientOrgKey,
      isNewConversation: true,
      onEntityInvited: onEntityInvited, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
    )
  )

  return {
    query: searchQuery,
    hasQuery: !!trimmed,
    setQuery,
    clearQuery,
    groups,
    options,
    active,
    setActive,
    pick,
    openInvite,
    phoneError,
    isLoadingResults,
    // Nothing found, and nothing to offer instead.
    isEmpty: !!trimmed && !isLoadingResults && !options.length && !phoneError,
    onKeyDown,
    onKeyUp,
    selectedChip,
    selectChip,
    deselectChip,
    inviteModal,
  }
}; exports.useToSearch = useToSearch


